export type TimeoutWarningPayload = {
	action: 'timeoutWarning';
	actionSubject: 'editorRovoBridge';
	actionSubjectId: 'editorPluginAI';
	attributes: {
		delayedAtMs: number;
		id: string | null;
		success: 'warning' | 'delayed';
	};
	eventType: 'track';
};

export const createWarningStreamPayload = ({
	delayedAtMs,
	success,
	id,
}: {
	delayedAtMs: number;
	id: string | null;
	success: 'warning' | 'delayed';
}): TimeoutWarningPayload => {
	return {
		action: 'timeoutWarning',
		actionSubject: 'editorRovoBridge',
		actionSubjectId: 'editorPluginAI',
		eventType: 'track',
		attributes: {
			// Whether it was a "warning" (ie. would have timed out) or it was successful but just delayed
			success,
			// Time the delay fires
			delayedAtMs,
			// In case we need to stitch delayed + warning together
			id,
		},
	};
};
